import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';

import Button from '../../../Components/Button';
import Image from '../../../Components/Image';
import ReadMore from '../../../Components/ReadMore';
import { textCategory } from '../../../Components/Reservation/constants';
import ReservationOverview from '../../../Components/Reservation/Overview';
import ResponsiveText from '../../../Components/ResponsiveText';
import { TableDetails } from '../../../RTK/api/reservations/types';
import { StoreDetails } from '../../../RTK/api/store/types';
import themeStyle from '../../../Theme/styles';
import breakpoints from '../../../Theme/styles/breakpoints';
import {
  ids as platformStyleIds,
  styles as platformStyles,
} from '../../../Theme/styles/platform';

type Props = TableDetails & {
  date: string;
  size: number;
  store: StoreDetails;
  time: string;
  onBookNow: () => void;
};

const ReservationItem = (props: Props) => {
  const { onBookNow, ...data } = props;
  const { experiences, is_communal, item, maximum, minimum, name } = data;

  return (
    <View dataSet={{ media: ids.wrapper }} style={styles.wrapper}>
      <View dataSet={{ media: ids.firstColumn }} style={styles.firstColumn}>
        <Button onPress={onBookNow} plain>
          <ResponsiveText
            category={textCategory.HEADING}
            style={[themeStyle.spacingBottomMedium, themeStyle.bold]}
          >
            {name}
          </ResponsiveText>
        </Button>
        <ReadMore
          category={textCategory.BODY}
          status="info"
          contentContainerStyle={themeStyle.spacingBottomMedium}
          maxChar={100}
          value={item.description}
        />
        <View style={themeStyle.spacingBottomMedium}>
          <ReservationOverview
            contentContainerStyle={themeStyle.spacingBottomXSmall}
            iconSize={25}
            textCategory={textCategory.SMALL_BODY}
            tableData={{
              is_communal,
              experiences,
              maximum,
              minimum,
            }}
          />
        </View>
        <View style={[themeStyle.flex1, themeStyle.flexDirectionRowCenter]}>
          <Button status="info" style={styles.noPadding} onPress={onBookNow}>
            {() => (
              <ResponsiveText
                appearance="alternative"
                category={textCategory.BODY}
                style={themeStyle.pageHorizontalSpacing}
              >
                Book Now
              </ResponsiveText>
            )}
          </Button>
        </View>
      </View>
      <View
        dataSet={{ media: `${ids.secondColumn} ${platformStyleIds.webOnly}` }}
        style={[platformStyles.webOnly, styles.secondColumn]}
      >
        <Button onPress={onBookNow} plain>
          <Image
            source={{ uri: item.image }}
            style={styles.image}
            resizeMode="cover"
          />
        </Button>
      </View>
    </View>
  );
};

export const { ids, styles } = StyleSheet.create({
  wrapper: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionColReverse,
    [`@media ${breakpoints.sm}`]: themeStyle.flexDirectionRow,
  },
  firstColumn: {
    [`@media ${breakpoints.xs}`]: {
      flex: 1,
    },
    [`@media ${breakpoints.sm}`]: {
      flex: 1,
    },
    [`@media ${breakpoints.md}`]: {
      flex: 1.5,
      ...themeStyle.spacingRight,
    },
    [`@media ${breakpoints.lg}`]: {
      flex: 1,
    },
    [`@media ${breakpoints.xl}`]: {
      flex: 1.75,
    },
  },
  secondColumn: {
    flex: 1,
  },
  image: {
    width: '100%',
    aspectRatio: 1.75 / 1,
    borderRadius: 10,
    overflow: 'hidden',
  },
  noPadding: { paddingVertical: 0 },
});

export default ReservationItem;
